const propertyBalanceState = {
  propertyBalanceSummary: null,
  loading: false,
};

export const propertyBalanceSummaryReducer = (state = propertyBalanceState, action) => {
  switch (action.type) {
    case "GET_PROPERTY_BALANCE_SUMMARY":
      return {
        ...state,
        propertyBalanceSummary: action.payload,
        loading: action.loader,
      };
    default:
      return state;
  }
};

const propertyRevenueState = {
  propertyRevenueByChargeHead: null,
  loading: false,
};

export const propertyRevenueByChargeHeadReducer = (state = propertyRevenueState, action) => {
  switch (action.type) {
    case "GET_PROPERTY_REVENUE_BY_CHARGE_HEAD":
      return {
        ...state,
        propertyRevenueByChargeHead: action.payload,
        loading: action.loader,
      };
    default:
      return state;
  }
};

const propertyTopDefaultersState = {
  propertyTopDefaulters: null,
  loading: false,
};

export const propertyTopDefaultersReducer = (state = propertyTopDefaultersState, action) => {
  switch (action.type) {
    case "GET_PROPERTY_TOP_DEFAULTERS":
      return {
        ...state,
        propertyTopDefaulters: action.payload,
        loading: action.loader,
      };
    default:
      return state;
  }
};

const propertyVoidAnalysisState = {
  propertyVoidAnalysis: null,
  loading: false,
};

export const propertyVoidAnalysisReducer = (state = propertyVoidAnalysisState, action) => {
  switch (action.type) {
    case "GET_PROPERTY_VOID_ANALYSIS":
      return {
        ...state,
        propertyVoidAnalysis: action.payload,
        loading: action.loader,
      };
    default:
      return state;
  }
};

const propertyPartialPaymentsState = {
  propertyPartialPayments: null,
  loading: false,
};

export const propertyPartialPaymentsReducer = (state = propertyPartialPaymentsState, action) => {
  switch (action.type) {
    case "GET_PROPERTY_PARTIAL_PAYMENTS":
      return {
        ...state,
        propertyPartialPayments: action.payload,
        loading: action.loader,
      };
    default:
      return state;
  }
};

const propertyInactiveChargesState = {
  propertyInactiveCharges: null,
  loading: false,
};

export const propertyInactiveChargesReducer = (state = propertyInactiveChargesState, action) => {
  switch (action.type) {
    case "GET_PROPERTY_INACTIVE_CHARGES":
      return {
        ...state,
        propertyInactiveCharges: action.payload,
        loading: action.loader,
      };
    default:
      return state;
  }
};

const propertyActiveBatchesStatusState = {
  propertyActiveBatchesStatus: null,
  loading: false,
};

export const propertyActiveBatchesStatusReducer = (state = propertyActiveBatchesStatusState, action) => {
  switch (action.type) {
    case "GET_PROPERTY_ACTIVE_BATCHES_STATUS":
      return {
        ...state,
        propertyActiveBatchesStatus: action.payload,
        loading: action.loader,
      };
    default:
      return state;
  }
};




